import { useStyles, Flex, Caption } from '@archipro-design/aria';
import * as S from './LatestArticles.style';
import { Link } from '@remix-run/react';
import ArchizeenTile from '~/modules/tile/component/archizeen-tile/ArchizeenImpressionTile';
import type { LatestArticlesProps } from '@modules/articles/component/latest-articles/LatestArticles';
import { useLocalisation } from '@archipro-website/localisation';
import { getFormattedLocalisedDate } from '@modules/date-time/util/get-localised-date';
import type { SiteVariablesArg } from '~/types/site-variables';

interface LatestArticlesMobileProps extends LatestArticlesProps {
    showCategory?: boolean;
}

const LatestArticlesMobile = ({
    latestArticles,
    title,
}: LatestArticlesMobileProps) => {
    const { css } = useStyles();
    const { localiseDate } = useLocalisation();
    return (
        <div className={css(S.Wrap)}>
            <Caption
                className={css(S.TitleWrap)}
                variant="02"
                weight="medium"
                variables={(siteVars: SiteVariablesArg) => ({
                    ...siteVars?.textStyles.Heading.Medium65,
                })}
            >
                {title}
            </Caption>

            <Flex column className={css(S.TileSlideWrap)}>
                {latestArticles.map((article) => {
                    const {
                        link,
                        ID,
                        professionalID,
                        title,
                        image: _,
                        canEdit: _canEdit,
                        bmEditorLink: _bmEditorLink,
                        date,
                        ...rest
                    } = article;

                    return (
                        <div className={css(S.TileSlide)} key={ID}>
                            <ArchizeenTile
                                key={ID}
                                as={Link}
                                to={link}
                                date={getFormattedLocalisedDate(
                                    localiseDate,
                                    date,
                                )}
                                prefetch="intent"
                                {...rest}
                                variant="04"
                                size={'small'}
                                favouritePosition="card"
                                title={{
                                    children: title,
                                    maximumLines: 3,
                                }}
                                impression={{
                                    professionalID: professionalID,
                                    itemID: ID,
                                    type: 'LibraryItem_Directory',
                                }}
                                image={{
                                    width: 118,
                                    height: 131,
                                    src: article.image,
                                    alt: title,
                                }}
                                articleId={ID}
                            />
                        </div>
                    );
                })}
            </Flex>
        </div>
    );
};

export default LatestArticlesMobile;
